import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';

// Generic typed hooks for shared code.
// Each app can create more specific typed hooks if needed.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useAppDispatch: () => any = useDispatch;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useAppSelector: TypedUseSelectorHook<any> = useSelector;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AppDispatch = any;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type RootState = any;
